export default (props, vars) =>
  vars?.['useform2']?.['register']('checkbox_CPT');
